import { useState } from "react";
import { bugsnag, createUUID } from "@miplatform/utils";

export const useComponentState = () => {
  const [abortControllersByUuid, setAbortControllersByUuid] = useState({});

  const run = async (task, externalUUID) => {
    const uuid = externalUUID || createUUID();
    try {
      const abortController = new AbortController();
      setAbortControllersByUuid((prev) => ({
        ...prev,
        [uuid]: abortController,
      }));
      const result = await task(abortController.signal);

      return result;
    } catch (err) {
      bugsnag.setContext("useComponentState::run");
      bugsnag.notify(err instanceof Error ? err : new Error(String(err)));
      throw err;
    } finally {
      setAbortControllersByUuid((prev) => {
        const { [uuid]: _, ...rest } = prev;
        return rest;
      });
    }
  };

  const abort = (uuid) => {
    const item = abortControllersByUuid[uuid];
    if (item) {
      item.abort();
    }
  };

  const abortAll = () => {
    const uuids = Object.keys(abortControllersByUuid);
    if (uuids.length) {
      uuids.forEach((key) => {
        abortControllersByUuid[key].abort();
      });
    }
  };

  const isBusy = () => Object.keys(abortControllersByUuid).length > 0;

  const getStatus = () => {
    if (isBusy()) {
      return "UPDATING";
    }
    return "READY";
  };

  const statusTag = (id) => (
    <span
      id={id}
      style={{
        visibility: "hidden",
        height: "0",
        width: "0",
        position: "absolute",
      }}
    >
      {getStatus()}
    </span>
  );

  return { run, statusTag, isBusy, abort, abortAll };
};
